


import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ArrowLeft, Search, Zap, Wrench, MessageSquare,
  CheckCircle, Calendar, AlertCircle, Star, Gift
} from 'lucide-react';
import "../../../../assets/css/screens/customer/dashboard/inbox/CustomerInbox.css";
import AppNavbar from '../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';
import AppContext from '../../../../context/AppContext';

const CustomerInbox = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const { Chat } =  useContext(AppContext);


  const notifications = [
    {
      id: 1,
      icon: <Zap size={24} />,
      iconBg: '#fef3c7',
      iconColor: '#f59e0b',
      sender: 'Ahmed Khan',
      message: "I'll be there at 10 AM tomorrow.",
      time: '2 min ago',
      unread: true,
      badge: 2
    },
    {
      id: 2,
      icon: <Wrench size={24} />,
      iconBg: '#fecaca',
      iconColor: '#ef4444',
      sender: 'Sarah Miller',
      message: 'The cleaning is done. Please check.',
      time: '1 hour ago',
      unread: false
    },
    {
      id: 3,
      icon: <CheckCircle size={24} />,
      iconBg: '#d1fae5',
      iconColor: '#10b981',
      sender: 'John Smith',
      message: 'Thank you for your feedback!',
      time: 'Yesterday',
      unread: false
    },
    {
      id: 4,
      icon: <MessageSquare size={24} />,
      iconBg: '#dbeafe',
      iconColor: '#3b82f6',
      sender: 'Work Hub Support',
      message: 'Your ticket has been resolved.',
      time: '2 days ago',
      unread: true,
      badge: 1
    },
    {
      id: 5,
      icon: <Calendar size={24} />,
      iconBg: '#e9d5ff',
      iconColor: '#a855f7',
      sender: 'Maria Garcia',
      message: 'Booking confirmed for tomorrow at 2 PM.',
      time: '3 days ago',
      unread: false
    },
    {
      id: 6,
      icon: <Star size={24} />,
      iconBg: '#fed7aa',
      iconColor: '#f97316',
      sender: 'Ali Hassan',
      message: 'Please rate your recent service.',
      time: '4 days ago',
      unread: false
    },
    {
      id: 7,
      icon: <Gift size={24} />,
      iconBg: '#fce7f3',
      iconColor: '#ec4899',
      sender: 'WorkHub Rewards',
      message: 'You have earned 50 points!',
      time: '5 days ago',
      unread: true,
      badge: 1
    },
    {
      id: 8,
      icon: <AlertCircle size={24} />,
      iconBg: '#fee2e2',
      iconColor: '#dc2626',
      sender: 'System Alert',
      message: 'Payment pending for booking #1234.',
      time: '1 week ago',
      unread: false
    }
  ];

const handleNotificationClick = (notificationId) => {
  Chat(notificationId);   // ✅ context me chat set
  navigate('/chat');          // ✅ clean URL
};

  const handleBack = () => {
    navigate(-1);
  };

  const filteredNotifications = notifications.filter(notif =>
    notif.sender.toLowerCase().includes(searchQuery.toLowerCase()) ||
    notif.message.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
    <AppNavbar/>
  
    <div className="inbox-page">
      
      {/* ════ HEADER ════ */}
      <div className="inbox-header">
        <button className="inbox-back-btn" onClick={handleBack}>
          <ArrowLeft size={24} />
        </button>
        <h2 className="inbox-title">Inbox</h2>
      </div>

      {/* ════ SEARCH BAR ════ */}
      <div className="inbox-search-wrapper">
        <div className="inbox-search">
          <Search className="inbox-search-icon" size={20} />
          <input
            type="text"
            className="inbox-search-input"
            placeholder="Search conversations..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>

      {/* ════ NOTIFICATIONS LIST ════ */}
      <div className="inbox-list">
        {filteredNotifications.length > 0 ? (
          filteredNotifications.map((notif) => (
            <div
              key={notif.id}
              className={`inbox-item ${notif.unread ? 'inbox-item--unread' : ''}`}
              onClick={() => handleNotificationClick(notif.id)}
            >
              {/* Icon */}
              <div 
                className="inbox-item-icon"
                style={{ 
                  backgroundColor: notif.iconBg,
                  color: notif.iconColor 
                }}
              >
                {notif.icon}
              </div>

              {/* Content */}
              <div className="inbox-item-content">
                <div className="inbox-item-header">
                  <h5 className="inbox-item-sender">{notif.sender}</h5>
                  <span className="inbox-item-time">{notif.time}</span>
                </div>
                <p className="inbox-item-message">{notif.message}</p>
              </div>

              {/* Badge */}
              {notif.badge && (
                <div className="inbox-item-badge">{notif.badge}</div>
              )}
            </div>
          ))
        ) : (
          <div className="inbox-empty">
            <MessageSquare size={64} />
            <h5>No conversations found</h5>
            <p>Try adjusting your search</p>
          </div>
        )}
      </div>

    </div>
      </>
  );
};

export default CustomerInbox;
